import Button, { ButtonProps } from './Button';

export type { ButtonProps };
export default Button;
